<template>
  <Layout style="height: 100%;" class="main">
    <Sider hide-trigger collapsible :width="200" :collapsed-width="64" v-model="collapsed" class="sider-wrapper" style="">
      <side-menu  accordion :active-name="toPathName?toPathName:$route.name " :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList"  @on-coll-change="handleCollapsedChange">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <!--<div class="logo-con">-->
          <!--<img v-show="!collapsed" :src="maxLogo" key="max-logo" />-->
          <!--<img v-show="collapsed" :src="minLogo" key="min-logo" />-->
        <!--</div>-->
      </side-menu>
    </Sider>
    <Header :class="['header-content',collapsed?'header-con-full':'']"  >
      <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
        <user :user-avator="userAvator"/>
        <!--<img :src="defaultAvator" key="max-logo" />-->
        <!--<language @on-lang-change="setLocal" style="margin-right: 10px;" :lang="local"/>-->
        <fullscreen v-model="isFullscreen" style="margin-right: 10px;"/>
      </header-bar>
    </Header>
    <!--<div class="tag-nav-wrapper">-->
      <!--<tags-nav :value="$route" @input="handleClick" :list="tagNavList" @on-close="handleCloseTag"/>-->
    <!--</div>-->
    <Content class="content-wrapper" style="min-width: 1085px;">
      <keep-alive :include="cacheList">
        <router-view/>
      </keep-alive>
    </Content>
  </Layout>
</template>
<script>
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import Fullscreen from './components/fullscreen'
import Language from './components/language'
import { mapMutations, mapActions } from 'vuex'
import { getNewTagList, getNextName } from '@/libs/util'
// import minLogo from '@/assets/images/logo-min.jpg'
// import maxLogo from '@/assets/images/logo.jpg'
import defaultAvator from '@/assets/images/avatar.png'
import './main.less'
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    Language,
    TagsNav,
    Fullscreen,
    User
  },
  data () {
    return {
      collapsed: false,
      // minLogo,
      // maxLogo,
      defaultAvator,
      isFullscreen: false,
    }
  },
  props:{
    // toPathName: {
    //   type: String,
    //   default () {
    //     console.log(this.$store.state.toPathName)
    //     return this.$store.state.toPathName
    //   }
    // },
  },
  computed: {
    toPathName(){
      // console.log(this.$store.state.toPathName)
      return this.$store.state.toPathName
    },
    tagNavList () {
      return this.$store.state.app.tagNavList
    },
    tagRouter () {
      return this.$store.state.app.tagRouter
    },
    userAvator () {
      // console.log(this.defaultAvator)
      // 改这里改这里 获取信息  用户头像，暂时为默认的
      // return this.$store.state.user.avatorImgPath
      return this.defaultAvator  //默认的
    },
    cacheList () {
      return this.tagNavList.length ? this.tagNavList.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []
    },
    menuList () {
      return this.$store.getters.menuList
    },
    local () {
      return this.$store.state.app.local
    }
  },
  methods: {
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setLocal'
    ]),
    ...mapActions([
      'handleLogin'
    ]),
    turnToPage (name) {
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name: name
      })

    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, name) {
      const nextName = getNextName(this.tagNavList, name)
      this.setTagNavList(res)
      if (type === 'all') this.turnToPage('home')
      else if (this.$route.name === name) this.$router.push({ name: nextName })
    },
    handleClick (item) {
      this.turnToPage(item.name)
      this.routerName = item.name;
    }
  },
  watch: {
    '$route' (newRoute) {
      this.setBreadCrumb(newRoute.matched)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.addTag(this.$store.state.app.homeRoute)
    this.setBreadCrumb(this.$route.matched)
    // 设置初始语言
    this.setLocal(this.$i18n.locale);
    // 文档提示
    // this.$Notice.open({
    //   title: '想快速上手，去看文档吧',
    //   duration: 0,
    //   render: (h) => {
    //     return h('p', {
    //       style: {
    //         fontSize: '13px'
    //       }
    //     }, [
    //       '点击',
    //       h('a', {
    //         attrs: {
    //           href: 'https://lison16.github.io/iview-admin-doc/#/',
    //           target: '_blank'
    //         }
    //       }, 'iview-admin2.0文档'),
    //       '快速查看'
    //     ])
    //   }
    // })
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/main.vue